import React, { useState, useEffect } from "react";
import { Row, Modal, Form, Input, Col, Button, Icon } from "antd";

import { PermissionsTransfer } from "./permissionsTransfer";
import { getPermissionsByIdMenu } from "../../../actions/index";
import { toArray } from "../../../components/util";

export function MenuEditor({ onCloseEditor, modelForm }) {
    const [showPermissions, setShowPermissions] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [menuPermissions, setMenuPermissions] = useState([]);

    useEffect(() => {
        if (modelForm) {
            const getMenuPermissions = async () => {
                const menuPermissions = await getPermissionsByIdMenu({
                    accao: "autorizacoes",
                    id: modelForm.idmenu,
                });
                const { autorizacoes, lista_autorizacoes } = menuPermissions;

                const menuPermissionList = toArray(autorizacoes?.linha);
                const listaAutorizacoes = toArray(lista_autorizacoes?.linha);

                setMenuPermissions(
                    menuPermissionList.map((item) => ({
                        key: item.idautorizacao,
                        ...item,
                    }))
                );

                setPermissions(
                    listaAutorizacoes.map((item) => ({
                        key: item.idautorizacao,
                        ...item,
                    }))
                );
            };

            getMenuPermissions();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelForm]);

    const handleOnCancel = () => {
        onCloseEditor();
    };
    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
    };

    return (
        <Modal
            destroyOnClose={true}
            width="80%"
            title={`Editar menu ${modelForm.activo === "f" ? "(Inativo)" : ""}`}
            visible
            footer={null}
            onCancel={handleOnCancel}
        >
            <Form layout="horizontal">
                <Row>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Título" {...formItemLayout}>
                            <Input
                                readOnly
                                value={modelForm && typeof modelForm.titulo !== "object" ? modelForm.titulo : undefined}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Descrição" {...formItemLayout}>
                            <Input
                                readOnly
                                value={
                                    modelForm && typeof modelForm.descricao !== "object"
                                        ? modelForm.descricao
                                        : undefined
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                        <Form.Item label="Posição" {...formItemLayout}>
                            <Input
                                readOnly
                                value={
                                    modelForm && typeof modelForm.posicao !== "object" ? modelForm.posicao : undefined
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                        <Form.Item label="Menu Pai" {...formItemLayout}>
                            <Input
                                readOnly
                                value={modelForm && typeof modelForm.pai !== "object" ? modelForm.pai : undefined}
                            />
                        </Form.Item>
                    </Col>

                    {/* <Col xs={24} sm={12}>
                        <Form.Item label="Ativo" {...formItemLayout}>
                            <Input
                                readOnly
                                value={modelForm && typeof modelForm.ativo !== "object" ? modelForm.ativo : undefined}
                            />
                        </Form.Item>
                    </Col> */}

                    <Col xs={24} sm={12}>
                        <Form.Item label="Ação" {...formItemLayout}>
                            <Input
                                readOnly
                                value={
                                    modelForm && typeof modelForm.webaccao !== "object" ? modelForm.webaccao : undefined
                                }
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Tipo" {...formItemLayout}>
                            <Input
                                readOnly
                                value={
                                    modelForm && typeof modelForm.webtipo !== "object" ? modelForm.webtipo : undefined
                                }
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Row>
                            <Button
                                type="primary"
                                icon="unlock"
                                style={{ margin: 2 }}
                                onClick={() => {
                                    if (showPermissions) setShowPermissions(false);
                                    else setShowPermissions(true);
                                }}
                            >
                                Permissões
                                {showPermissions ? <Icon type="up" /> : <Icon type="down" />}
                            </Button>
                        </Row>
                        {showPermissions && (
                            <Row style={{ top: 5 }}>
                                <PermissionsTransfer
                                    webtipo={modelForm.webtipo}
                                    webaccao={modelForm.webaccao}
                                    idmenu={modelForm.idmenu}
                                    onCloseEditor={onCloseEditor}
                                    leftDataSource={permissions}
                                    rightDataSource={menuPermissions}
                                />
                            </Row>
                        )}
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
